import Vue from 'vue'
import TumengSvgIcon from '../../packages/svg-icon/src/index.vue'

// register globally
Vue.component(TumengSvgIcon.name, TumengSvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
